import { render } from "./Abt1Sta.vue?vue&type=template&id=38558cd1"
import script from "./Abt1Sta.vue?vue&type=script&lang=js"
export * from "./Abt1Sta.vue?vue&type=script&lang=js"

import "./Abt1Sta.vue?vue&type=style&index=0&id=38558cd1&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__